import { render, staticRenderFns } from "./Mods.vue?vue&type=template&id=4b642cf4&"
import script from "./Mods.vue?vue&type=script&lang=js&"
export * from "./Mods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports